<svg:g>
  @for (bar of bars; track trackBy(i, bar); let i = $index) {
    <ng-container>
      <svg:g
        ngx-charts-bar
        [width]="bar.width"
        [height]="bar.height"
        [x]="bar.x"
        [y]="bar.y"
        [fill]="bar.color"
        [stops]="bar.gradientStops"
        [data]="bar.data"
        [orientation]="barOrientation.Vertical"
        [roundEdges]="bar.roundEdges"
        [gradient]="gradient"
        [ariaLabel]="bar.ariaLabel"
        [isActive]="isActive(bar.data)"
        (select)="selectOffer()"
        (activate)="activate.emit($event)"
        (deactivate)="deactivate.emit($event)"
        ngx-tooltip
        [tooltipDisabled]="tooltipDisabled"
        [tooltipPlacement]="tooltipPlacement"
        [tooltipType]="tooltipType"
        [tooltipTitle]="tooltipTemplate ? undefined : bar.tooltipText"
        [tooltipTemplate]="tooltipTemplate"
        [tooltipContext]="bar.data"
        [noBarWhenZero]="noBarWhenZero"
        [animations]="animations"
        ></svg:g>
      <text [attr.id]="'bar-text-'+prefix+'_'+pos+'-'+i" [attr.x]="bar.x+5"
            [attr.y]="bar.y+20"
            style="font-size: 14px; pointer-events: none;"
            class="link"
            [attr.fill]="(isLightColor(bar.color))?'#58504e':'#ffffff'">{{getFormattedText(bar.value, i)}}</text>
      </ng-container>
    }
    </svg:g>